import React from 'react';
import PropTypes from 'prop-types';

import withChannelFormatters from '../../../containers/channelUtils/withChannelFormatters';
import FieldSelect from '../../fields/fieldSelect/FieldSelect';


function DropdownVariantPicker({availableVariants, selectedVariant, onChange, channelFormatters}) {
  return (
    <FieldSelect
      input={{
        value: selectedVariant.id.toString(),
        onChange: evt => onChange(availableVariants.find(it => it.id === parseInt(evt.target.value)))
      }}>
      {availableVariants.sort((a, b) => a.position - b.position).map(variant => (
        <option key={variant.id} value={variant.id}>
          {variant.name}
          &nbsp;-&nbsp;
          {channelFormatters.currencySymbol()}
          {channelFormatters.price(variant.price)}
        </option>
      ))}
    </FieldSelect>
  );
}


export default withChannelFormatters(DropdownVariantPicker);



// WEBPACK FOOTER //
// ./components/productPurchase/variantPickers/DropdownVariantPicker.js